module.exports = __webpack_public_path__ + "media/AI_welcome.0bc86ac2.mp4";